import { Theme, VerivestTheme } from "@verivest/shared-components";

export { VerivestTheme as customTheme };
export default Theme;
